import styled from 'styled-components';
import { globals } from 'shared/styles/settings';
import { space } from 'styled-system';

export const Emoji = styled.div`
  font-size: ${props =>
    globals.iconSizes[props.size] || globals.iconSizes.base};
  line-height: 1;
  ${space};
`;

export default Emoji;
